import { db } from '@/firebase/firebaseInit';
import { collection, query, orderBy, where, getDocs, onSnapshot, addDoc, updateDoc, arrayUnion, doc, serverTimestamp, Timestamp } from "firebase/firestore";

let unsubscribeFn = null;

export default {
    subscribeInterests(context) {
        if (unsubscribeFn) return;
        const q = query(collection(db, "interests"), orderBy("createdAt", "desc"));
        unsubscribeFn = onSnapshot(q, (snapshot) => {
            const interests = [];
            snapshot.forEach((d) => {
                const interest = d.data();
                interest.id = d.id;
                interests.push(interest);
            });
            context.commit('setInterests', interests);
        });
    },

    unsubscribeInterests() {
        if (unsubscribeFn) {
            unsubscribeFn();
            unsubscribeFn = null;
        }
    },

    async checkUserHasSubmitted(context, volunteerID) {
        const q = query(collection(db, "interests"), where("volunteerID", "==", volunteerID));
        const snapshot = await getDocs(q);
        context.commit('setHasSubmitted', !snapshot.empty);
    },

    async submitInterest(context, payload) {
        await addDoc(collection(db, "interests"), {
            volunteerID: payload.volunteerID,
            volunteerName: payload.volunteerName,
            volunteerEmail: payload.volunteerEmail,
            areas: payload.areas,
            status: "NEW",
            notes: "",
            createdAt: serverTimestamp()
        });
    },

    async updateInterest(context, { id, status }) {
        const updateData = {};
        if (status !== undefined) updateData.status = status;
        await updateDoc(doc(db, "interests", id), updateData);
    },

    async addInterestNote(context, { id, text, authorName, authorEmail }) {
        const note = {
            text,
            authorName,
            authorEmail,
            createdAt: Timestamp.now()
        };
        await updateDoc(doc(db, "interests", id), {
            notes_trail: arrayUnion(note)
        });
    }
}
